import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { I18nProvider } from "@/contexts/I18nContext";
import { ProfileModalProvider } from "@/contexts/ProfileModalContext";
import { GlobalConfigProvider } from "@/contexts/GlobalConfigContext";
import { ConfirmProvider } from "@/contexts/ConfirmContext";
import GlobalProfileModal from "@/components/ProfileModal";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import PublicViewer from "@/pages/PublicViewer";
import BrandsOverview from "@/pages/BrandsOverview";
import AcceptOwnership from "@/pages/AcceptOwnership";
import AcceptInvite from "@/pages/AcceptInvite";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SuperAdmin from "@/pages/SuperAdmin";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginGate />} />
      <Route path="/view/:slug" element={<PublicViewer />} />
      <Route path="/brands" element={<BrandsOverviewGate />} />
      <Route path="/accept-ownership" element={<AcceptOwnership />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/super-admin" element={<SuperAdmin />} />
      <Route path="/*" element={<DashboardGate />} />
    </Routes>
  );
}

function DashboardGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#3a372b]">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Dashboard />;
}

function LoginGate() {
  const { user } = useAuth();
  if (user) return <Navigate to="/brands" replace />;
  return <Login />;
}

function BrandsOverviewGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#3a372b]">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <BrandsOverview />;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <GlobalConfigProvider>
              <ProfileModalProvider>
                <ConfirmProvider>
                  <AppRouter />
                  <GlobalProfileModal />
                  <Toaster position="bottom-right" />
                </ConfirmProvider>
              </ProfileModalProvider>
            </GlobalConfigProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}
